import { Injectable, EventEmitter } from '@angular/core';
import { PubNubAngular } from 'pubnub-angular2';
import { environment } from '../../../environments/environment';

@Injectable()
export class PubNubService {
  $pubnubEmitter = new EventEmitter<any>();
  pubnub;
  networkStatus;
  currentUser: any;

  messageSentJSONArr = []; // json string of messages that are sent so as to avoid DUPLICATES
  messageReceivedJSONArr = []; // json string of messages that are received so as to avoid DUPLICATES

  constructor(private pubnubService: PubNubAngular) {
    this.pubnub = pubnubService;
    // this.connect();

    this.messageSentJSONArr = []; // reset
    this.messageReceivedJSONArr = []; // reset

    this.pubnub.init({
      publishKey: environment.PUBNUB_PUBLISH_KEY,
      subscribeKey: environment.PUBNUB_SUBSCRIBE_KEY
    });
    console.log(this.pubnub, 'pubnub connected');
  }

  subscribeTo(channel?: string) {
    this.pubnub.reconnect();
    this.pubnub.removeAllListeners();

    if (!channel) {
      this.currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));

      if (!this.currentUser) return;
      channel = `opscomm_${this.currentUser._id}`;
    }

    console.log('subscribed to channel', channel);

    this.pubnub.subscribe({
      channels: [channel || 'test'],
      restore: true,
      channelGroups: [],
      withPresence: true,
      triggerEvents: ['message', 'presence', 'status']
    });

    this.pubnub.addListener({
      status: async statusEvent => {
        console.log('Pubnub:PubnubStatus', statusEvent);

        if (
          this.networkStatus === 'PNNetworkDownCategory' &&
          statusEvent.category === 'PNNetworkUpCategory'
        ) {
          this.subscribeTo();
          console.log(statusEvent.category, 'Network is back Reconnecting to pubnub');
        }
        this.networkStatus = statusEvent.category;
        console.log(this.networkStatus, 'network status');
      },
      message: async messageEvent => {
        const date = new Date();
        console.log(
          `********Pubnub****: message received by ${channel} at ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} : `,
          messageEvent.message
        );

        // if EXACT already received, then do not send it
        // if (
        //   this.messageReceivedJSONArr.includes(
        //     JSON.stringify(messageEvent.message)
        //   )
        // ) {
        //   console.log(
        //     "This exact PUBNUB message was already received, hence early exiting"
        //   );
        //   return false;
        // }

        this.emitPubNubMsg(messageEvent.message);

        this.messageReceivedJSONArr.push(JSON.stringify(messageEvent.message)); // save for future reference
      }
    });
  }
  emitPubNubMsg(msg) {
    this.$pubnubEmitter.emit(msg);
  }
  publishMsg(msg: any, channel?: string) {
    if (!channel) {
      channel = `opscomm_all`;
    }

    // if EXACT already sent, then do not send it
    // if (this.messageSentJSONArr.includes(JSON.stringify(msg))) {
    //   console.log(
    //     "This exact PUBNUB message was already sent, hence early exiting"
    //   );
    //   return false;
    // }

    this.pubnub.publish(
      {
        message: msg,
        channel
      },
      (status, response) => {
        const date = new Date();
        // tslint:disable-next-line:max-line-length
        console.log(
          `********Pubnub****: message sent to ${channel} at ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} : `,
          msg
        );

        this.messageSentJSONArr.push(JSON.stringify(msg)); // save for future reference
      }
    );
  }

  fetchMessages(channel?: string) {
    return new Promise((resolve, reject) => {
      if (!channel) {
        this.currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
        channel = `opscomm_${this.currentUser._id}`;
      }

      this.pubnub.history(
        {
          channel: channel,
          count: 100
        },
        (status, response) => {
          const date = new Date();
          // tslint:disable-next-line:max-line-length
          console.log(
            `********Pubnub****: fetch messages ${channel} at ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()} : `,
            response
          );
          resolve(response);
          // this.messageSentJSONArr.push(JSON.stringify(msg)); // save for future reference
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/pubnub.service.ts